import { Button, Grid } from '@material-ui/core';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import axios from "axios";
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { API_URL, AUTHORITY } from "../../Const";
import GenericTemplate from "../templates/GenericTemplate";
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';



const UserDetail: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay()

  /*id取得*/
  const { state } = useLocation();
  const id = (state as any)?.id;
  const comid = (state as any)?.comid;

  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')


  const [posts, setPosts] = useState<any[]>([])
  useEffect(() => {
    openLoading()
    axios.post(API_URL.USER_GET,
      {
        "user_id": id,
        "company_id": comid
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        const persons = res.data.data;
        setPosts(persons)
      })
      .catch(error => {
        console.log(error)
        //let jsonObject = JSON.parse(error);
      })
      .finally(() => {
        closeLoading()
      })
  }, []);
  console.log(posts)
  const user_name = (posts as any)?.user_name;
  const user_name_kana = (posts as any)?.user_name_kana;
  const user_id = (posts as any)?.user_id;
  const authority_code = (posts as any)?.authority_code;
  const remarks = (posts as any)?.remarks;


  return (
    <GenericTemplate title="ユーザ 詳細">
      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} >
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">ユーザー名</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              variant="standard"
              inputProps={{ readOnly: true }}
              value={user_name}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">フリガナ</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              variant="standard"
              inputProps={{ readOnly: true }}
              value={user_name_kana}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">メールアドレス</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              variant="standard"
              inputProps={{ readOnly: true }}
              value={user_id}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">パスワード</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              variant="standard"
              inputProps={{ readOnly: true }}
              value="-"
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">権限</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              variant="standard"
              inputProps={{ readOnly: true }}
              value={AUTHORITY[authority_code]}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">備考</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              variant="standard"
              inputProps={{ readOnly: true }}
              value={remarks}
            />
          </Grid>
        </Grid>
      </Stack>
      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={0} margin={0}>
        <Grid container spacing={0}>
          <Grid item xs={2}>
            <Button
              className="btnlink"
              color="primary"
              variant="contained"
              size="large"
              component={Link}
              to="/Userlist"
            >
              戻る
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button
              className="btnlink"
              style={{ color: "#fff", backgroundColor: "#FFA500" }}
              variant="contained"
              size="large"
              component={Link}
              // to="/Useredit"
              to={{ pathname: "/Useredit", state: { user_id: user_id, company_id: comid, user_name: user_name, user_name_kana: user_name_kana, authority_code: authority_code, remarks: remarks } }}
            >
              ユーザー情報編集
            </Button>
          </Grid>
        </Grid>
      </Stack>
    </GenericTemplate>
  );
};

export default UserDetail;